import { memo } from "react";

interface SpinnerProps {
  color?: string;
  size?: number;
}

function Spinner({ color = "#353535", size = 16 }: SpinnerProps) {
  return (
    <>
      {/* Keyframes can't be expressed as a style attribute, so they are declared once here. */}
      <style>
        {`
          @keyframes trl-spinner-rotate {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <span
        data-testid="spinner"
        style={{
          animation: "trl-spinner-rotate 0.8s linear infinite",
          border: `2px solid ${color}33`,
          borderRadius: "50%",
          borderTopColor: color,
          boxSizing: "border-box",
          display: "inline-block",
          height: size,
          width: size,
        }}
      />
    </>
  );
}

export default memo(Spinner);
